document.querySelectorAll('.faq, .faq__item').forEach(details => {
  const summary = details.querySelector('summary');
  
  summary.addEventListener('click', (e) => {

    // summary内のリンクをクリックした場合はアコーディオン処理をしない
    if (e.target.closest('a')) {
      return;
    }

    e.preventDefault();
    
    if (details.open) {
      details.classList.remove('is-animating');
      
      const startHeight = details.offsetHeight;
      const endHeight = summary.offsetHeight;
      
      details.style.height = `${startHeight}px`;
      details.style.overflow = 'hidden';

      details.animate([
        { height: `${startHeight}px` },
        { height: `${endHeight}px` }
      ], { duration: 300, easing: 'ease-out' }).onfinish = () => {
        details.open = false;
        details.style.height = '';
      };
    } else {
      details.classList.add('is-animating');
      
      details.open = true;
      const endHeight = details.offsetHeight;
      const startHeight = summary.offsetHeight;
      
      details.animate([
        { height: `${startHeight}px` },
        { height: `${endHeight}px` }
      ], { duration: 300, easing: 'ease-out' }).onfinish = () => {
        details.style.height = '';
      };
    }
  });
});
document.querySelectorAll('a[href^="#"]').forEach(link => {
  link.addEventListener('click', function(e) {
    e.preventDefault();

    const target = document.querySelector(this.getAttribute('href'));
    const offset = 0; // ヘッダーの高さ

    const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const navItems = document.querySelectorAll('.guide-nav .tabs__label');
  const tabs = document.querySelectorAll('.guide-main .guide-tab');
  const select = document.querySelector('.guide-nav select[name="guide-select"]');

  if (!navItems.length || !tabs.length) return;
  const showTab = (index) => {
    navItems.forEach((item, i) => {
      item.classList.toggle('active', i === index);
    });
    tabs.forEach((tab, i) => {
      tab.style.display = i === index ? 'block' : 'none';
    });
    if (select) {
      select.selectedIndex = index;
    }
  };

  navItems.forEach((item, index) => {
    item.addEventListener('click', () => {
      showTab(index);
    });
  });
  if (select) {
    select.addEventListener('change', () => {
      showTab(select.selectedIndex);
    });
  }
  const defaultIndex =
    [...navItems].findIndex((item) => item.classList.contains('active')) || 0;
  showTab(defaultIndex >= 0 ? defaultIndex : 0);
});